import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import { SourceDetail } from 'v2/core/entities/feedback/sources';
import { SourceName } from 'v2/core/entities/fields';
import { Timezone, User } from 'v2/core/entities/user';
import { UUID } from 'v2/core/entities/uuid';
import useGetSourceDetailsMap from 'v2/core/repository/edge-server/source-details';
import { AndStatuses, QueryStatus } from 'v2/core/repository/edge-server/types';
import { Response } from 'v2/core/services/types';
import { useGetUser } from 'v2/core/services/user';

interface AnalysisDeps {
  user: User;
  tenantID: UUID;
  timezone: Timezone;
  tenantSlug: string | undefined;
  taxonomyID?: UUID;
  sourceDetailsMap?: Map<SourceName, SourceDetail>;
}

interface AnalysisDepsResponse extends Response<AnalysisDeps> {
  data: AnalysisDeps;
}

const useGetAnalysisDeps = (): AnalysisDepsResponse => {
  const user = useGetUser();
  const taxonomyID = useTaxonomyStore(({ taxonomyID }) => taxonomyID);
  const isLoading = useTaxonomyStore(({ view }) => view.isLoading);

  const {
    data: sourceDetailsMap,
    status: sStatus,
    error,
  } = useGetSourceDetailsMap();

  const status = AndStatuses([
    isLoading ? QueryStatus.IN_PROGRESS : QueryStatus.SUCCESS_COMPLETED,
    sStatus,
  ]);

  return {
    data: {
      user,
      tenantID: user.tenant.id,
      timezone: user.tenant.timezone,
      tenantSlug: user.tenant.slug,
      taxonomyID: taxonomyID ?? '',
      sourceDetailsMap,
    },
    status,
    error,
  };
};

export default useGetAnalysisDeps;
